import { FC } from 'react';
import { useHistory } from 'react-router';
import FormGroup from 'components/form/FormGroup';
import FormRowGroup from 'components/form/FormRowGroup';
import Form from 'components/form/Form';
import { useActiveClientContext } from 'store/active-client';
import { buildClientUrl } from 'utils/helpers/client';
import { IInputs } from '../types';

interface IProps {
  methods: any;
  handleSubmit: (data: IInputs) => void;
  btnLabel: string;
  canEdit?: boolean;
  isMultilingual?: boolean | null;
}

const SegmentForm: FC<IProps> = ({ methods, handleSubmit, btnLabel, canEdit, isMultilingual }: IProps) => {
  const { client } = useActiveClientContext();
  const history = useHistory();
  return (
    <Form
      methods={methods}
      onSubmit={handleSubmit}
      onCancel={() => history.push(buildClientUrl('/segments', client))}
      btnLabel={btnLabel}
      isHorizontal
      isSubmitDisabled={!canEdit}
    >
      {isMultilingual ? (
        <FormRowGroup>
          <FormGroup
            controlId="formGroupName"
            label="Име на сегмента"
            type="text"
            name="name"
            isRequired
            isDisabled={!canEdit}
            isRowGroup
          />
          <FormGroup
            controlId="formGroupNameEn"
            label="Segment name"
            type="text"
            name="name_en"
            isDisabled={!canEdit}
            isRowGroup
          />
        </FormRowGroup>
      ) : (
        <FormGroup
          controlId="formGroupName"
          label="Име на сегмента"
          type="text"
          name="name"
          isRequired
          isHorizontal
          isDisabled={!canEdit}
        />
      )}
      <FormGroup
        controlId="formGroupStatus"
        label="Активно"
        checkType="switch"
        name="is_active"
        isRequired
        isHorizontal
        isDisabled={!canEdit}
      />
    </Form>
  );
};

export default SegmentForm;
